import { Calendar, CheckCircle2 } from "lucide-react"
import { HashLink } from "react-router-hash-link"
import BaseHeadline from "../general/BaseHeadline"
import BaseLabel from "../general/BaseLabel"
import { PopupButton } from "react-calendly"

const guarantees = ["Kein Vendor Lock-in", "Voller Quellcode-Zugriff", "DSGVO-konformes Hosting"]

export default function ContactCTA() {
    return (
        <section className="w-full py-20 px-4 sm:px-8 xl:px-0 bg-base-100">
            <div className="max-w-page mx-auto flex flex-col md:flex-row justify-between md:items-center gap-12">
                <div className="flex-1 max-w-2xl">
                    <BaseHeadline
                        headline="Erzählen Sie uns von Ihrer Idee"
                        label="Lassen Sie uns sprechen"
                        headlineClassProps="leading-tight"
                        text="Keine unverbindlichen Versprechungen. Wir analysieren den Status Quo und zeigen konkretes Potenzial."
                        textClassProps="max-w-xl leading-relaxed"
                    />

                    
                    <button
                        className={`bg-primary mt-8 relative flex items-center py-3 px-8 rounded-3xl w-fit gap-4 transition-all ease-in duration-300 group border border-transparent hover:bg-base-100 hover:border hover:border-secondary`}>
                        <p className="lowercase text-accent">Termin vereinbaren</p>
                        <Calendar size={20} />
                        <PopupButton
                            url={"https://calendly.com/niklas-wicode/30min"}
                            text={""}
                            rootElement={document.getElementById("root") as HTMLElement}
                            className="w-full h-full absolute"
                        />
                    </button>
                </div>

                <div className="flex flex-col gap-10 min-w-[300px]">
                    <div>
                        <BaseLabel
                            label="Unsere Garantien"
                            color="secondary"
                        />
                        <ul className="space-y-4 pt-4">
                            {guarantees.map((item) => (
                                <li key={item} className="flex items-center gap-3 text-base-content">
                                    <CheckCircle2 className="w-5 h-5 text-primary" />
                                    <span className="text-base md:text-lg font-medium font-text">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="flex flex-col">
                        <BaseLabel
                            label="Direkter Kontakt"
                            color="primary"
                            classProps="mb-2"
                        />
                        <HashLink
                            to="/contact#_"
                            className="text-xl w-fit font-semibold text-base-content border-b-2 border-base-content hover:text-primary hover:border-primary transition-colors inline-block font-text"
                        >
                            Kontaktformular
                        </HashLink>
                    </div>
                </div>
            </div>
        </section>
    )
}
